import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'isStoreUuid',
  standalone: true,
})
export class IsStoreUuidPipe implements PipeTransform {
  transform(allowedUuid: string[], uuid: string): boolean {
    return allowedUuid.includes(uuid);
  }
}
